/**
 * Adoptar el perfil de un cliente sin cambiar la sesión del servidor.
 *
 * El API sigue siendo el del admin. Lo que cambia es el chrome: el panel
 * se ve como lo ve el dueño. Vive en sessionStorage — sobrevive a un F5
 * y se va al cerrar la pestaña.
 */
export const CLAVE_VER_COMO = 'agendify.verComo'

export interface VistaCliente {
    accountId: number
    nombre: string
}

export function leerVerComo(): VistaCliente | null {
    try {
        const raw = sessionStorage.getItem(CLAVE_VER_COMO)
        if (!raw) return null
        const v = JSON.parse(raw) as Partial<VistaCliente>
        if (typeof v.accountId !== 'number' || !Number.isFinite(v.accountId) || v.accountId <= 0) {
            return null
        }
        if (typeof v.nombre !== 'string') return null
        return { accountId: v.accountId, nombre: v.nombre }
    } catch {
        return null
    }
}

export function escribirVerComo(v: VistaCliente | null): void {
    try {
        if (v === null) sessionStorage.removeItem(CLAVE_VER_COMO)
        else sessionStorage.setItem(CLAVE_VER_COMO, JSON.stringify(v))
    } catch {
        /* modo privado */
    }
}

/** Rutas de operación que un dueño no ve. `/` la resuelve RaizPorRol. */
export function esRutaDeOperacion(pathname: string): boolean {
    return pathname === '/health' || pathname.startsWith('/altas') || pathname.startsWith('/retencion') || pathname.startsWith('/mcp-facebook') || pathname.startsWith('/whatsapp')
}
